import { Color } from '@coast/schemas';
import { View } from '@shared/components/View';
import { Pill } from '@shared/components/pill';
import { grid } from '@shared/styles';
import { API } from '@shared/types/api';

// A tag as the picker shows it: its color, or gray and italic once archived
export function TagOptionPill({ option }: { option: API.TagComponentOption }) {
  return (
    <View row centerVertically flex>
      <Pill
        backgroundColor={
          option.archived ? 'backgroundGrayLight' : (option.backgroundColor as Color)
        }
        round
        italic={option.archived ?? false}
        style={{ marginLeft: grid(0.5) }}
      >
        {option.label}
      </Pill>
    </View>
  );
}
